/**
 * @desc this module designed exclusively for main category navigation
 */
'use strict';

var util = require('./util'),
lazyloading = require('./lazyloading');

var navigation = {
	init: function () {
		var self = this;
		if (!util.viewport.isSmall()) {
			self.setMarginTopForTertiaryContent();
		}
		if (!SitePreferences.RETRIEVE_SUBCATEGORIES_CONTENT) {
			$(document).ready(function () {
				self.getCategoryMenu();
			});
		}

		self.getCategoryMobileMenu();
		self.initializeDomEvents();
		//close all navigation dropdowns on
		$(window).smartresize(function () {
			if (!util.viewport.isSmall()) {
				$('.main-navigation').find('.hover').removeClass('hover');
				$('.main-navigation').removeAttr('style');
			}
			$('.main-navigation > .nav-banner').hide();
			self.getCategoryMobileMenu();
			self.initializeDomEvents();
			if (!SitePreferences.RETRIEVE_SUBCATEGORIES_CONTENT) {
				self.getCategoryMenu();
			}
		});
	},

	initializeDomEvents: function () {
		var self = this,
			eventListener = util.viewport.isSmall() ? 'click' : 'touchstart mouseenter';
		//Top Level Category Link
		$('.category-title-link').off().on(eventListener, function (e) {

			var $mainCatContainer = $(this).closest('.top-level');

			if (!$(this).hasClass('has-sub-menu')) {
				$('.main-navigation .top-level').removeClass('hover');
				$mainCatContainer.addClass('hover');
				return true;
			}

			if (!$mainCatContainer.hasClass('hover')) {
				e.preventDefault();
				if (SitePreferences.RETRIEVE_SUBCATEGORIES_CONTENT && !$mainCatContainer.find('.sub-level').length) {
					self.updateSubcategoryContent($mainCatContainer);
				} else {
					self.showMainDropDown($mainCatContainer);
				}
				util.renderClosePadForTouch(false, 'dropDown');

				if (util.viewport.isSmall()) {
					$mainCatContainer.find('.sub-level-item, .has-sub-menu-level-2, .sub-level-content').removeClass('hover');
				}

				$('#navigation').find('.uiLayerIndicator').remove();
				$mainCatContainer.find('.nav-banner').show();
			}
		});

		self.initializeSecondaryCategoriesEvents();
		self.initAssetsLazyLoad();
	},
	initializeSecondaryCategoriesEvents: function () {
		var self = this;
		// Level 2 Category Link
		$('.has-sub-menu-level-2').on('click', function (e) {
			if (util.viewport.isSmall()) {
				var $this = $(this);
				var $subLevelContainer = $this.closest('.sub-level');
				var $subLevelItem = $this.closest('.sub-level-item');

				if ($this.hasClass('hover')) {
					// Click on minus sign
					if ($(e.target).closest('.fa-minus').length > 0) {
						e.preventDefault();
						$subLevelContainer.find('.sub-level-item, .has-sub-menu-level-2, .sub-level-content').removeClass('hover');
					}
				} else {
					e.preventDefault();
					$subLevelContainer.find('.sub-level-item, .has-sub-menu-level-2, .sub-level-content').removeClass('hover');
					$subLevelItem.addClass('hover');
					$this.addClass('hover');
					$subLevelItem.find('.sub-level-content').addClass('hover');

					util.renderClosePadForTouch(false, 'dropDown');
					$('#navigation').find('.uiLayerIndicator').remove();
					$('.main-navigation').scrollTop($('.main-navigation').scrollTop() + $this.position().top);
				}
			}
		});

		//Sub Category content (tertiary links/image)
		$('.sub-level-item').on('touchstart mouseenter', function (e) {
			if (!util.viewport.isSmall()) {
				var $subContent = $(this).find('.sub-level-content');
				if (!$(this).hasClass('hover')) {
					e.preventDefault();
					self.showSubContent($(this), $subContent);
					if (util.viewport.isMedium()) {
						self.handleMediumViewport($subContent);
					} else if (util.viewport.isStandard || util.viewport.isLarge) {
						self.adjustDropDownPosition($subContent);
					}
				}
			}
		});
	},
	setMenuHeight: function () {
		var maxMenuHeight = $(window).height() - $('#navigation').height() - 10;
		if ($('#header-cookies-message:visible').length > 0) {
			maxMenuHeight -= $('#header-cookies-message:visible').height();
		}
		$('.main-navigation').css({
			'maxHeight': maxMenuHeight + 'px'
		});
	},
	adjustDropDownPosition: function ($content) {
		var $subLevel = $content.closest('.sub-level'),
			currentPosition = $subLevel.position().left,
			thresholdOffset = $('.main-navigation').width() - $content.data('width');
		if (currentPosition > thresholdOffset) {
			$subLevel.css('left', thresholdOffset + 'px');
		}
	},
	/**
	 * hide menu, then open sub categories for main category,
	 * then show content of the first sub category
	 */
	showMainDropDown: function (topLevel) {
		$('.main-navigation .top-level').removeClass('hover')
			.find('.sub-level').removeClass('hover');
		topLevel.addClass('hover')
			.find('.sub-level').addClass('hover')
			.trigger('mouseenter');
		if (topLevel.find('.lazyAsset').length) {
			topLevel.find('.lazyAsset').show();
		}
	},
	/**
	 * @desc hide dropdown content of sub categories and banners before
	 * showing content of given sub category
	 */
	showSubContent: function (link, container) {
		$('.sub-level-item').removeClass('hover');
		$('.sub-level-content').removeClass('hover');
		$('.sub-level').css('left', 'initial');
		link.addClass('hover');
		container.addClass('hover');
	},

	handleMediumViewport: function ($content) {
		var $nav = $('.main-navigation'),
			$container = $content.closest('.sub-level'),
			isTwoColumns = $content.find('.third-level-items').hasClass('split-columns'),
			img = $content.find('.img'),
			widthDelta = 230,
			banner;

		if (!(isTwoColumns && img.length > 0)) {
			widthDelta = 0;
			img.addClass('show-medium');
		}
		$nav.width($content.data('width') - widthDelta + 'px');
		banner = $container.find('.nav-banner').html();
		if (banner) {
			banner.hide();
			$nav.children('.nav-banner').html(banner).show();
		}
	},

	/**
	 * @des set MarginTop for tertiaryContent based on it's position
	 * is needed only for standard and large viewports
	 */
	setMarginTopForTertiaryContent: function () {
		$('.sub-level-content').each(function () {
			var topMargin = $(this).data('margin') * 40;
			$(this).css('margin-top', '-' + topMargin + 'px');
		});
	},
	/**
	 * @desc check if main category has either two columns of tertiary categories
	 * or has at least one third level category and image link.
	 * In both cases it would create 3 or 4 columns which is required to render banner
	 */
	showBanner: function () {
		$('.main-navigation .sub-level-content').each(function () {
			var thirdLevel = $(this).find('.third-level-items'),
				imgLink = $(this).find('.img');

			if ((thirdLevel && thirdLevel.hasClass('split-columns')) ||
					(thirdLevel.length > 0 && imgLink.length > 0)) {
				$(this).addClass('show-banner');
			}

		});
	},

	/*
	 * Loops through and creates a data-id for the each element
	 *
	 * @method createDataId
	 * @param {string} elm Element receicving data-id
	 * @return VOID
	 *
	 */
	createDataId: function (elm) {
		elm.each(function (i) {
			$(this).attr('data-id', 'level-id-' + (i + 1));
		});
	},
	/**
	 * Get the content of the sub category,
	 * update the respective subcategory element
	 */
	updateSubcategoryContent: function (topLevel) {
		var self = this;
		$.ajax({
			url: Urls.includeSubcategoryContent,
			type: 'GET',
			data: {categoryID : topLevel.data('category-id'), format: 'ajax'},
			contentType: 'application/json',
			success: function (response) {
				topLevel.append(response);
				self.initializeSecondaryCategoriesEvents();
				self.showMainDropDown(topLevel);
			},
			error: function (err) {
				console.error(err);
			}
		});
	},
	/**
	 * Get the content of all categories and subcategories
	 */
	getCategoryMenu: function () {
		var self = this;
		var isMobileView = window.innerWidth <= window.Constants.STANDARD_BREAK_POINT;
		if (isMobileView) {
			return;
		}
		var menuWrapper = $('#desktop-navigation');
		var topLevelCategories = menuWrapper.find('.top-level');
		var subCategories = menuWrapper.find('.subcategory-wrapper');
		if (topLevelCategories.length && topLevelCategories.length === subCategories.length) {
			return;
		}

		$.ajax({
			url: Urls.includeSubcategories,
			type: 'GET',
			dataType: 'html',
			success: function (response) {
				topLevelCategories.each(function () {
					var $category = $(this);
					if ($category.find('.subcategory-wrapper').length) {
						return;
					}
					var categoryID = $category.data('category-id');
					var subcategoryWrapper = $(response).filter(`.subcategory-wrapper[data-category-id=${categoryID}]`);
					if (subcategoryWrapper.length) {
						$category.append(subcategoryWrapper);
					}
				});
				self.initializeSecondaryCategoriesEvents();
				self.initAssetsLazyLoad();
			},
			error: function (err) {
				console.error(err);
			}
		});
	},
	/**
	 * Get the content of all categories and subcategories for mobile
	 */
	getCategoryMobileMenu: function () {
		var self = this;
		var isMobileView = window.innerWidth <= window.Constants.STANDARD_BREAK_POINT;
		if (!isMobileView) {
			return;
		}
		var menuWrapper = $('#hamburger-menu');
		var url = Urls.includeHeaderMobileMenu;
		var topLevelCategories = menuWrapper.find('.top-level');
		var subCategories = menuWrapper.find('.subcategory-wrapper');
		if (topLevelCategories.length && topLevelCategories.length === subCategories.length) {
			return;
		}
		if (SitePreferences.RETRIEVE_SUBCATEGORIES_CONTENT) {
			url = Urls.IncludeTopCategoriesMenu;
		}

		$.ajax({
			url: url,
			type: 'GET',
			dataType: 'html',
			success: function (response) {
				menuWrapper.find('.drop-down-options.menu-wrapper').append(response);
				self.initializeDomEvents();
				self.initAssetsLazyLoad();
			},
			error: function (err) {
				console.error(err);
			}
		});
	},
	/**
	 * init lazy loading of content assets in categories
	 */
	initAssetsLazyLoad: function (container) {
		var self = this;
		var lazyAssets = container ? container.find('.lazyAsset') : $('.top-level .lazyAsset');
		if (SitePreferences.LAZYLOAD_ENABLED && SitePreferences.LAZY_LOAD_CONTENT_ENABLED && lazyAssets.length) {
			lazyAssets.each(function () {
				var topLevelCategory = $(this).closest('.top-level');
				lazyloading.init(topLevelCategory);
				topLevelCategory.on('lazyLoadComplete', function(e, data) {
					if (data.contentID) {
						topLevelCategory.find('.sub-level').addClass('hover').trigger('mouseenter');
						self.initializeSecondaryCategoriesEvents();
					}
				});
			});
		}
	}
};
module.exports = navigation;
